import { call, put, takeLatest } from "redux-saga/effects"

import { GET_LIST_RANKS_WATCHER } from "./constants"
import { getListRanksSuccess, getListRanksFailed } from "./actions"
import { getListRanksApi } from "../../../utils/routes/routes-report"

export function* getListRanksSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: resultTotal } = yield call(getListRanksApi, dataStatus.params)
    yield put(getListRanksSuccess(resultTotal))
  } catch (e) {
    yield put(getListRanksFailed())
  }
}

export default function* widgetAnalysisSegmentSaga() {
  yield takeLatest(GET_LIST_RANKS_WATCHER, getListRanksSaga)
}
